import { useFormSchema } from "src/api/hooks/useFormSchema";

export const NumberWidget = (props: any) => {
  const { value, onChange, label, required, id, uiSchema } = props;
  const { data: schema } = useFormSchema();
  const { minimum, maximum, step } = schema?.schema || {};
  const primaryColor = schema?.theme?.colors?.primary;

  return (
    <div className={`number-container container`}>
      <input
        type="number"
        className={`input-number`}
        value={value ?? ""}
        onChange={(e) => {
          const val =
            e.target.value === "" ? undefined : Number(e.target.value);
          onChange(val);
        }}
        min={minimum}
        max={maximum}
        step={step || "any"}
        required={required}
      />
    </div>
  );
};
